import BaseBehavior from '../../../framework/base/base';
import { showElement, hideElement } from '../../../shared/utilities/show-hide';

export default class TablesFilter extends BaseBehavior {
	constructor(element) {
		super(element);
		this.addSubscriptions();
	}

	getSpinner(isDesktop) {
		const selector = isDesktop
			? '.inspiration-table__content-section'
			: '.inspiration-table__content-section-mobile';
		return this.element.parentElement.querySelector(selector + ' .v2-loading-indicator');
	}

	onChange({ value }) {
		const isDesktop = this.element.dataset.inspirationView !== 'mobile';
		const requestBody = {
			datasourceid: this.element.dataset.datasourceid,
			language: this.element.dataset.language,
			probability: value,
			isDesktop
		};
		const spinner = this.getSpinner(isDesktop);
		showElement(spinner);
		window
			.fetch(this.element.dataset.apiUrl, {
				method: 'POST',
				headers: {
					Accept: 'text/*, text/html, text/html;level=1, */*',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(requestBody)
			})
			.then(response => {
				if (!response.ok) throw response.statusText;
				return response.text();
			})
			.then(html => {
				isDesktop ? this.updateDesktopView(html) : this.updateMobileView(html);
			})
			.catch(e => {
				// eslint-disable-next-line no-console
				console.error(`request failed : ${e}`);
			})
			.then(() => {
				hideElement(spinner);
			});
	}

	updateDesktopView(responseHtml) {
		const tmpTable = document.createElement('table');
		tmpTable.innerHTML = responseHtml;
		const noDataDiv = this.element.parentElement.querySelector('.no-data');
		if (!tmpTable.firstElementChild.children.length) {
			showElement(noDataDiv);
		} else {
			hideElement(noDataDiv);
		}
		const table = this.element.nextElementSibling;
		const tbody = table.querySelector('tbody');
		tbody.innerHTML = tmpTable.firstElementChild.innerHTML;
	}

	updateMobileView(responseHtml) {
		const tmpDiv = document.createElement('div');
		tmpDiv.innerHTML = responseHtml;
		const tmpContentSection = tmpDiv.firstElementChild;
		if (!tmpContentSection.querySelectorAll('.inspiration-table__row').length) {
			showElement(tmpContentSection.querySelector('.no-data'));
		}
		const tableContainer = this.element.nextElementSibling;
		const contentSection = tableContainer.querySelector(
			'.inspiration-table__content-section-mobile'
		);
		contentSection.innerHTML = tmpContentSection.innerHTML;
	}

	addSubscriptions() {
		this.subscribe(`/cb-dropdown/change`, data => {
			if (data.dropdownId && data.dropdownId === this.element.dataset.dropdownId)
				this.onChange(data);
		});
	}

	removeSubscriptions() {
		this.unsubscribe(`/cb-dropdown/change`);
	}

	cleanup() {
		this.removeSubscriptions();
	}
}
